// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-azap","header__logo":"Header_header__logo__IZtIA"};